import { Button } from '@/components/ui/button'
import { Api } from '@/lib/utils'
import { useStore } from '@/store'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Plus, Loader2 } from 'lucide-react'
import { ManualWalletLoadButton } from '@/components/ui/ManualWalletLoadButton'
import { useEffect } from 'react'
import { useShallow } from 'zustand/shallow'


export const Route = createFileRoute('/_auth/wallet')({
    component: RouteComponent,
})

function RouteComponent() {
    const {token, selectedAccount, setPage, phone, email} = useStore(useShallow(state => ({
        token: state.token, 
        selectedAccount: state.selectedAccount.id, 
        phone: state.phoneNumber, 
        email: state.email, 
        setPage: state.setPage
    })))

    const getOrderInfo = useQuery({
        queryKey: ['walletInfo', token],
        queryFn: () => Api<{ status: number, embed_link: string }>('/webui/wallet_info', "POST", {}, { token }),
        staleTime: Infinity,
        refetchInterval: Infinity,
        refetchOnWindowFocus: false
    })

    useEffect(() => {
        setPage('Wallet')
    }, [])

    return <div className={`absolute left-0 right-0 md:top-[80px] top-[50px] bottom-3 md:px-5 md:py-3 px-2`}>
        <div className={`flex flex-row-reverse sm:items-end items-start justify-between p-2 sm:flex-row-reverse  my-1`}>
            <a href={`https://pages.razorpay.com/prorouting-wallet-recharge?phone=${phone || ''}&email=${email || ''}&accountid=${selectedAccount}`} target='_blank'>
                <Button aria-label={`Recharge Wallet by ${email} ${phone}`} size={'lg'}>
                    <Plus />
                    Recharge Wallet
                </Button>
            </a>
            {email?.endsWith('prorouting.in') && useStore.getState().selectedAccount.role === 'super_admin' && (
                <ManualWalletLoadButton />
            )}
        </div>
        <div className={`absolute left-2 right-2 bottom-2 top-[60px] overflow-auto lg:left-5 lg:right-5 md:top-[85px]`}>
            {getOrderInfo.data?.embed_link ? <div onMouseDown={e => e.stopPropagation()}>
                <iframe src={getOrderInfo.data.embed_link} className="absolute right-0 top-0 bottom-0 left-0 w-full h-full" />
            </div> : getOrderInfo.isFetching ? <div className='w-full h-full flex justify-center items-center'><Loader2 /></div> : null}
        </div>
    </div>
}
